import(/* webpackMode: "eager", webpackExports: ["Battles"] */ "/vercel/path0/src/components/Battles/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeLayout"] */ "/vercel/path0/src/components/Layouts/HomeLayout.tsx");
